import { render, staticRenderFns } from "./addModify-plan.vue?vue&type=template&id=38d56778&scoped=true"
import script from "./addModify-plan.vue?vue&type=script&lang=js"
export * from "./addModify-plan.vue?vue&type=script&lang=js"
import style0 from "./addModify-plan.vue?vue&type=style&index=0&id=38d56778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_rj3s3qgubxnefw7btmb34khrpq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d56778",
  null
  
)

export default component.exports